import { memo, SetStateAction, useEffect, useState } from 'react';
import { Slider } from 'antd';
import { PriceSliderProps, TSliderItem, TMarks } from './PriceSliderDeductible.types';
import styles from './PriceSliderDeductible.module.scss';
import NormalPrice from '../NormalPrice';
import { ConfigProvider } from 'antd';

const PriceSliderDeductible = memo((props: PriceSliderProps) => {
  const [min, setMin] = useState(0);
  const [max, setMax] = useState(0);
  const [curIndex, setCurIndex] = useState(0);
  const [marks, setMarks] = useState<TMarks>({});
  const [itemList, setItemList] = useState<TSliderItem[]>([]);

  const changeValue = (index: number) => {
    const curValue = itemList[index].value;
    setCurIndex(index);
    props.onChange && props.onChange(curValue);
  };

  useEffect(() => {
    const tempMarks: SetStateAction<TMarks> = {};
    const tempItemList: SetStateAction<TSliderItem[]> = [];
    props?.marks?.forEach((item, index) => {
      if (item?.deductible?.is_default) {
        setCurIndex(index);
      }
      tempItemList.push({
        callout_label: item.deductible.callout_label,
        value: item.deductible.value
      });
      tempMarks[index] = <NormalPrice fontSize={14} price={item.deductible.value} />;
    });
    setMin(0);
    setMax(props?.marks?.length - 1);
    setMarks(tempMarks);
    setItemList(tempItemList);
  }, []);

  return (
    <div className={styles.price_slider}>
      <div className={styles.price_title_wrapper}>
        <div className={styles.price_title}>自付費</div>
        <div style={{ display: 'flex', alignItems: 'center' }}>
          {itemList?.[curIndex]?.callout_label && (
            <div className={styles.plan_tag}>{itemList?.[curIndex]?.callout_label}</div>
          )}
          <NormalPrice fontSize={16} price={props.value || 0} />
        </div>
      </div>
      <ConfigProvider
        theme={{
          components: {
            Slider: {
              // 滑块
              handleColor: '#E87722',
              handleLineWidth: 4,
              handleLineWidthHover: 4,
              handleSize: 16,
              handleSizeHover: 16,
              // 轨道
              railBg: '#B3B6B8',
              railHoverBg: '#B3B6B8',
              trackBg: '#E87722',
              trackHoverBg: '#E87722'
            }
          }
        }}
      >
        <Slider
          tooltip={{ open: false }}
          onChange={changeValue}
          value={curIndex}
          min={min}
          max={max}
          marks={marks}
          step={null}
        />
      </ConfigProvider>
    </div>
  );
});
export default PriceSliderDeductible;
